import React from 'react';
import { Tooltip } from '@meitu/saas-ui';
import { type EventEmitter } from '@meitu/saas-editor-core/es/framework/services/events';
import { type StageToolbar } from '@meitu/saas-editor-core/es/plugins/stage-toolbar';
import IconFont from '@meitu/xdesign-icon-font';
import { useEditor } from '@/hooks/use-editor';
import { useLocaleStore } from '@/i18n';
import { ICallback, IToolLayout } from '../../types';

interface OtherProps {
    events: EventEmitter;
}

const SortBtn = ({ id, onSort }: Pick<IToolLayout & ICallback & OtherProps, 'id' | 'onSort'>) => {
    const { $t } = useLocaleStore();
    const editor = useEditor();
    return (
        <Tooltip placement="bottom" title={$t((v) => v.headerToolbar.sortBtn.order)}>
            <div
                onClick={(e) => {
                    const rect = (e.target as HTMLElement).getBoundingClientRect();
                    const top = rect.top + rect.height;

                    editor.getInstance<StageToolbar>('StageToolbar').toggleHierarchy({
                        position: {
                            bottom: 'auto',
                            top,
                        },
                        source: 'api',
                    });
                    onSort?.();
                }}
                className="c-header-toolbar-actions-btn"
            >
                <IconFont fontSize={14} name="LayerBold" />
            </div>
        </Tooltip>
    );
};

export default React.memo(SortBtn);
